import { queryBlogList } from '@queries'
import { IBlogPost } from '@types'
import { GetStaticProps, NextPage } from 'next'
import { getGraphQLData } from '../database/graphQL/apollo'
import { BlogContainer } from '@components/blog/BlogContainer'
import { AppLayout } from '@components'

export const getStaticProps: GetStaticProps = async () => {
  const response = await getGraphQLData<{ allBlogs: IBlogPost[] }>(
    queryBlogList,
  )

  return {
    props: {
      blogPosts: response?.allBlogs.filter(post => post.category == 'Events'),
    },
    revalidate: 10,
  }
}

const Blogs: NextPage<{
  blogPosts: IBlogPost[]
}> = ({ blogPosts }) => {
  return (
    <AppLayout>
      <BlogContainer blogPosts={blogPosts} category="Events" />
    </AppLayout>
  )
}

export default Blogs
